<template>
  <div class="sc-body">
    <SectionHero
      @cv-open="showSalesModal"
    />

    <SectionVideo/>

    <SectionMoney/>

    <SectionBenefits/>

    <SectionTeam
      @cv-open="$modal.show('cv-upload-sales');"
    />

    <SectionValues/>

    <SectionJoin
      @cv-open="$modal.show('cv-upload-sales');"
    />

    <SectionStories/>

    <ModalCVUploadSales/>

  </div>
</template>

<script>
import SectionHero from '@/components/SCSectionHero.vue';
import SectionVideo from '@/components/SCSectionVideo.vue';
import SectionMoney from '@/components/SCSectionMoney.vue';
import SectionBenefits from '@/components/SCSectionBenefits.vue';
import SectionTeam from '@/components/SCSectionTeam.vue';
import SectionValues from '@/components/SCSectionValues.vue';
import SectionJoin from '@/components/SCSectionJoin.vue';
import SectionStories from '@/components/SCSectionStories.vue';
import ModalCVUploadSales from '@/components/ModalCVUploadSales.vue';

export default {
  components: {
    SectionHero,
    SectionVideo,
    SectionMoney,
    SectionBenefits,
    SectionTeam,
    SectionValues,
    SectionJoin,
    SectionStories,
    ModalCVUploadSales,
  },
  props: ['href'],
  mounted() {
    if (this.href === 'podme-na-to') {
      this.showSalesModal();
    } else if (this.href) {
      const interval = setInterval(() => {
        const el = document.getElementById(this.href);

        if (el) {
          clearInterval(interval);
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 1);
    }
  },
  methods: {
    showSalesModal() {
      this.$modal.show('cv-upload-sales');
    },
  },
};
</script>

<style lang="scss">
.sc-body {
  color: $gray-600;
  overflow-x: hidden;
  p {
    margin-bottom: 20px;
  }
  .sc-title {
    font-size: 32px;
    margin-bottom: 50px;
    &.-center {
      text-align: center;
    }
    &.-small-margin {
      margin-bottom: 20px;
    }
    @media screen and (min-width: $screen-md) {
      font-size: 44px;
    }
  }
  .sc-lead {
    font-size: 16px;
    &.-center {
      text-align: center;
      max-width: 800px;
      margin: 0 auto;
    }
    @media screen and (min-width: $screen-md) {
      font-size: 20px;
    }
  }
}
</style>
